/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEligibilityUpdatedPayload } from "./AccessEligibilityUpdatedPayload";
import type { ConversationClosedPayload } from "./ConversationClosedPayload";
import type { ConversationListUpdatedPayload } from "./ConversationListUpdatedPayload";
import type { CSATRequestedPayload } from "./CSATRequestedPayload";
import type { DateOfBirthRequestPayload } from "./DateOfBirthRequestPayload";
import type { IdVerificationUpdatedPayload } from "./IdVerificationUpdatedPayload";
import type { ImageGenerationUpdatedPayload } from "./ImageGenerationUpdatedPayload";
import type { PatientResponsibilityUpdatedPayload } from "./PatientResponsibilityUpdatedPayload";
import type { SignupNudgePayload } from "./SignupNudgePayload";
import type { VideoVisitEndedPayload } from "./VideoVisitEndedPayload";
import type { VideoVisitStartedPayload } from "./VideoVisitStartedPayload";
import type { VisitTakenPayload } from "./VisitTakenPayload";

export type FrontendSideEffectEvent =
  | VisitTakenPayload
  | ConversationClosedPayload
  | CSATRequestedPayload
  | SignupNudgePayload
  | ConversationListUpdatedPayload
  | VideoVisitStartedPayload
  | VideoVisitEndedPayload
  | DateOfBirthRequestPayload
  | ImageGenerationUpdatedPayload
  | IdVerificationUpdatedPayload
  | PatientResponsibilityUpdatedPayload
  | AccessEligibilityUpdatedPayload;
